var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "restrict-inscan-flag"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading,
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fetchHubsByFlag.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Fetch Hubs By Flag")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Select Flag Name")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.flagOptions,
      "selected-option": _vm.selectedFlag,
      "placeholder": "Select a flag name"
    },
    on: {
      "select": _vm.setSelectedFlag
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Select the flag to fetch hub.")]), _vm._v(" "), (_vm.flagError) ? _c('div', {
    staticClass: "text-danger mt-1"
  }, [_vm._v("\n                  " + _vm._s(_vm.flagError) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 d-flex align-items-end"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_vm._v("\n                  Clear\n                ")])])])])])], 1)]), _vm._v(" "), (_vm.showResults) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("\n        Hubs (" + _vm._s(_vm.hubs.length) + ")\n        "), (_vm.hubs.length > 0) ? _c('button', {
    staticClass: "common-info float-right",
    on: {
      "click": _vm.downloadCSV
    }
  }, [_vm._v("\n          Download CSV\n        ")]) : _vm._e()]), _vm._v(" "), _c('b-card', [(!_vm.hubs.length) ? _c('div', {
    staticClass: "text-center text-muted py-2"
  }, [_vm._v("\n          No Hubs Found\n        ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover tbl hubs-table"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Hub ID")]), _vm._v(" "), _c('th', [_vm._v("Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedHubs), function(hub, idx) {
    return _c('tr', {
      key: hub.hubid || idx
    }, [_c('td', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.pageSize + idx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hub.hubid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hub.hubname))]), _vm._v(" "), _c('td', [_c('span', {
      class: hub.flagvalue ? 'text-success' : 'text-danger'
    }, [_vm._v("\n                  " + _vm._s(hub.flagvalue ? 'Active' : 'Inactive') + "\n                ")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn-icon",
      attrs: {
        "title": "View Logs"
      },
      on: {
        "click": function($event) {
          return _vm.fetchLogs(hub.hubid, hub.hubname)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pagination-controls d-flex justify-content-between align-items-center mt-2"
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.paginatedHubs.length) + " of " + _vm._s(_vm.hubs.length) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group pagination-group",
    attrs: {
      "role": "group",
      "aria-label": "Pagination"
    }
  }, [_c('button', {
    staticClass: "common-success prev-next",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_vm._v("\n              Prev\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "page-numbers",
    attrs: {
      "role": "tablist",
      "aria-label": "Page numbers"
    }
  }, _vm._l((_vm.visiblePages), function(p) {
    return _c('button', {
      key: p,
      staticClass: "page-num",
      class: {
        'active-page': p === _vm.currentPage
      },
      attrs: {
        "type": "button",
        "disabled": p === '...',
        "aria-current": p === _vm.currentPage ? 'page' : null
      },
      on: {
        "click": function($event) {
          p !== '...' ? _vm.changePage(p) : null
        }
      }
    }, [_vm._v("\n                " + _vm._s(p) + "\n              ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "common-success prev-next",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage === _vm.totalPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("\n              Next\n            ")])])])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "logs-modal",
      "size": "xl",
      "modal-dialog-class": "modal-xl",
      "modal-class": "bordered-modal",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('div', {
          staticClass: "modal-header custom-modal-header d-flex justify-content-between align-items-center w-100"
        }, [_c('div', [_c('h5', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.currentHubName || 'Logs'))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("History / status changes")])]), _vm._v(" "), _c('button', {
          staticClass: "close",
          attrs: {
            "type": "button",
            "aria-label": "Close"
          },
          on: {
            "click": function($event) {
              _vm.showLogsModal = false
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function() {
        return [_c('div', {
          staticClass: "w-100 d-flex justify-content-end logs-modal-footer"
        }, [_c('button', {
          staticClass: "btn common-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.downloadLogsCSV
          }
        }, [_vm._v("\n            Download CSV\n          ")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.showLogsModal),
      callback: function($$v) {
        _vm.showLogsModal = $$v
      },
      expression: "showLogsModal"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "modal-body logs-modal-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover tbl logs-table"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', [(!_vm.currentLogs.length) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted no-logs",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                No logs found\n              ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentLogs), function(log, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(log.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(log.date))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle text-center"
    }, [_c('span', {
      class: log.status === 'Active' ? 'text-success' : 'text-danger'
    }, [_vm._v("\n                  " + _vm._s(log.status) + "\n                ")])])])
  })], 2)])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c099f526","hasScoped":true}!./src/views/components/ExportRestrictTempInscanMapping/ExportRestrictTempInscanMapping.html
// module id = 1738
// module chunks = 2